var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGefionFacility8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8324 26.4593L79.0541 16.8673L75.6989 0L1.83875 14.6915L3.44296 22.7575C1.38328 23.986 0 26.2357 0 28.8032C0 31.8609 1.96125 34.4676 4.6914 35.4354V80H79.9986V26.4593H30.8324ZM65.6383 31.147L57.8383 38.947H49.3365L57.1365 31.147H65.6383ZM50.5072 31.147L42.7073 38.947H34.2054L42.0054 31.147H50.5072ZM35.3762 31.147L27.5762 38.947H19.0743L26.8743 31.147H35.3762ZM12.4451 38.947H9.37904V35.4354C11.3754 34.7277 12.9598 33.1435 13.6675 31.147H20.245L12.4451 38.947ZM69.031 6.10561L72.016 5.51186L73.5419 13.1843L62.8846 15.3042L69.031 6.10561ZM54.1905 9.05764L62.5289 7.39905L56.3825 16.5978L48.0441 18.2564L54.1905 9.05764ZM39.3502 12.0094L47.6888 10.3508L41.5424 19.5495L33.2038 21.2081L39.3502 12.0094ZM24.51 14.9614L32.8484 13.3028L26.702 22.5015L18.3636 24.1601L24.51 14.9614ZM18.0081 16.2547L12.5429 24.4339C11.4506 23.0598 9.8567 22.102 8.03998 21.8411L7.35045 18.3748L18.0081 16.2547ZM7.0353 31.1506C5.74093 31.1506 4.6878 30.0976 4.6878 28.8032C4.6878 27.5089 5.74093 26.4557 7.0353 26.4557C8.32967 26.4557 9.38264 27.5089 9.38264 28.8032C9.38264 30.0976 8.32967 31.1506 7.0353 31.1506ZM75.3111 75.3122H9.37904V43.6346H75.311V75.3122H75.3111ZM75.3113 38.947H75.3111H64.4677L72.2677 31.147H75.3114V38.947H75.3113Z",
    fill: "#C49A36"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGefionFacility8);
export default __webpack_public_path__ + "static/media/gefion-facility-8.4ca8aa6b.svg";
export { ForwardRef as ReactComponent };